window.init_input_check = function() {
  // console.log("...input check called")

  function input_validate(class_name) {
    $(class_name).find('input').each(function() {
      $(this).css('border-color', '#ccc')
      val = $(this).val();
      if (val == '') {
        $(this).css('border-color', 'red')
      }
    });
  }

  $('.check_valid').click(function() {
    input_validate('.form-horizontal');
  });

  $('.reset_password').click(function() {
    input_validate('.reset_password_form');
  });

  $('#resetCancel').click(function() {
    $('.reset_password_form input').css('border-color', '#ccc')
    // input_validate('.reset_password_form');
  });

  // function security_form() {
  //   if (($("#security_decision_form").val()) === 'true') {
  //     $('.security_decision_form').find('input').each(function() {
  //       $(this).prop("disabled", true)
  //     });
  //     $('.security_decision_form').find('select').each(function() {
  //       $(this).prop("disabled", true)
  //     });
  //   }
  // }

  // function loan_form() {
  //   if (($("#loans_decision_form").val()) === 'true') {
  //     $('.loans_decision_form').find('input').each(function() {
  //       $(this).prop("disabled", true)
  //     });
  //     $('.loans_decision_form').find('select').each(function() {
  //       $(this).prop("disabled", true)
  //     });
  //   }
  // }

  // function deposit_form() {
  //   if (($("#deposits_decision_form").val()) === 'true') {
  //     $('.deposits_decision_form').find('input').each(function() {
  //       $(this).prop("disabled", true)
  //     });
  //     $('.deposits_decision_form').find('select').each(function() {
  //       $(this).prop("disabled", true)
  //     });
  //   }
  // }

  // function treasury_form() {
  //   if (($("#treasury_decision_form").val()) === 'true') {
  //     $('.treasury_decision_form').find('input').each(function() {
  //       $(this).prop("disabled", true)
  //     });
  //     $('.treasury_decision_form').find('select').each(function() {
  //       $(this).prop("disabled", true)
  //     });
  //   }
  // }


  // security_form();
  // loan_form();
  // deposit_form();
  // treasury_form();


  $('.team_membership_member').click(function() {
    normal_color();
    $(this).css('color', '#005a8c') //#555
  });

  $('.team_membership_reset_password').click(function() {
    normal_color();
  });

  function normal_color() {
    $('.team_membership_member').css('color', '#555');
  }
}
